<template>
  <td
    @click.stop
  >
    <v-checkbox
      v-if="!deliveryDate.date"
      :input-value="selected"
      color="success"
      @change="$emit('change')"
    />
    <DeliveryToolTip
      v-else
      :delivery="deliveryDate"
      include-date
    >
      <v-checkbox
        v-if="deliveryDate.status <= 0"
        :input-value="true"
        disabled
      />
      <v-icon
        v-else
        color="grey"
      >
        mdi-alert-circle-outline
      </v-icon>
    </DeliveryToolTip>
  </td>
</template>

<script>
import DeliveryToolTip from './DeliveryToolTip'
export default {
  name: 'CheckBox',
  components: {
    DeliveryToolTip
  },
  props: {
    deliveryDate: {
      type: Object,
      required: true
    },
    selected: {
      type: Boolean,
      default: () => false
    }
  }
}
</script>
